// extracted by mini-css-extract-plugin
export var fullHeightState = "_5s-7";
export var headerCell = "_5s-1";
export var loadingStateCell = "_5s-4";
export var rowWrapper = "_5s-3";
export var standaloneTable = "_5s-8";
export var standaloneTableWithBodyFill = "_5s-9";
export var stateCell = "_5s-5";
export var table = "_5s-0";
export var tableBodyFiller = "_5s-6";
export var white = "_5s-2";